module.exports = __webpack_public_path__ + "static/media/ZellaTech-LogoSMS-.53d0ca9c.png";